export enum LoadingMode {
  AbTest = 'abTest',
  AbTestV2 = 'abTestV2',
  Default = 'default',
  HideUI = 'hideUI',
}

interface LoadingModeResult {
  mode: LoadingMode;
  autoStart: boolean;
}

export const useLoadingMode = (
  hideUI: boolean,
  miniGameEnabled: boolean,
  miniGameV2Enabled: boolean
): LoadingModeResult => {
  if (!hideUI) return { mode: LoadingMode.Default, autoStart: false };
  if (miniGameV2Enabled) return { mode: LoadingMode.AbTestV2, autoStart: false };
  if (miniGameEnabled) return { mode: LoadingMode.AbTest, autoStart: false };
  return { mode: LoadingMode.HideUI, autoStart: true };
};
